import * as React from "react"
import styled from "styled-components"

const MobileDropdownWrapper = styled.div`
  display: flex;
  z-index: 100;
  flex-direction: column;
  width: auto;
`

const MobileDropdownMenuItem = styled.div`
  display: inline-block;
  font-size: 18px;
  line-height: 20px;
  font-weight: normal;
`

const MobileDropdown = props => (
  <MobileDropdownWrapper>
    {props.children.map((el, i) => (
      <MobileDropdownMenuItem key={i}>{el}</MobileDropdownMenuItem>
    ))}
  </MobileDropdownWrapper>
)

export default MobileDropdown
